import React, { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CheckboxOption from '../../FormOptions/CheckboxOption';

/** Renders a Restoration-style checkbox card backed by an array form field. */
const CheckboxCardRhf = ({ label, name, value, disabled = false, readOnly = false }) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field }) => {
                const selectedValues = Array.isArray(field.value) ? field.value : [];
                const isChecked = selectedValues.includes(value);

                return (
                    <CheckboxOption
                        label={label}
                        checked={isChecked}
                        disabled={disabled || readOnly}
                        className="restorative-checkbox-card"
                        selectedClassName="restorative-checkbox-selected"
                        onChange={(event) => {
                            const updatedValues = event.target.checked
                                ? [...selectedValues, value]
                                : selectedValues.filter((selectedValue) => selectedValue !== value);
                            field.onChange(updatedValues);
                        }}
                    />
                );
            }}
        />
    );
};

export default memo(CheckboxCardRhf);
